import React from 'react';

const StructuredData = ({ type, data = {} }) => {
  let structuredData = {};

  switch (type) {
    case 'Organization':
      structuredData = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        '@id': 'https://globetune.co.uk/#organization',
        name: 'GlobeTune',
        url: 'https://globetune.co.uk',
        logo: {
          '@type': 'ImageObject',
          url: 'https://globetune.co.uk/Logo.png',
          width: '112',
          height: '112'
        },
        description: 'Listen to radio stations from around the world. Discover local and international radio stations, music, news, and entertainment in one place.',
        sameAs: [
          'https://twitter.com/globetune',
          'https://facebook.com/globetune',
          'https://instagram.com/globetune'
        ],
        ...data
      };
      break;
    case 'WebApplication':
      structuredData = {
        '@context': 'https://schema.org',
        '@type': 'WebApplication',
        '@id': 'https://globetune.co.uk/#webapplication',
        name: 'GlobeTune',
        applicationCategory: 'MultimediaApplication, EntertainmentApplication',
        operatingSystem: 'Windows, macOS, Android, iOS',
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'USD',
          availability: 'https://schema.org/InStock'
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.8',
          ratingCount: '1024',
          bestRating: '5',
          worstRating: '1'
        },
        applicationSuite: 'GlobeTune Radio Network',
        ...data
      };
      break;
    case 'WebSite':
      structuredData = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        '@id': 'https://globetune.co.uk/#website',
        name: 'GlobeTune',
        url: 'https://globetune.co.uk',
        potentialAction: {
          '@type': 'SearchAction',
          'target': {
            '@type': 'EntryPoint',
            'urlTemplate': 'https://globetune.co.uk/search?q={search_term_string}'
          },
          'query-input': 'required name=search_term_string'
        },
        ...data
      };
      break;
    case 'RadioStation':
      structuredData = {
        '@context': 'https://schema.org',
        '@type': 'RadioStation',
        '@id': `https://globetune.co.uk/station/${data.id || 'unknown'}#radiostation`,
        name: data.name || 'Radio Station',
        url: `https://globetune.co.uk/station/${data.id || 'unknown'}`,
        contentUrl: data.streamUrl,
        genre: data.genre || 'Various',
        broadcastDisplayName: data.name || 'Radio Station',
        broadcastTimezone: data.timezone || 'UTC',
        image: data.logo || 'https://globetune.co.uk/default-station.png',
        inLanguage: data.language || 'en',
        audio: {
          '@type': 'AudioObject',
          contentUrl: data.streamUrl || '',
          encodingFormat: 'audio/mpeg',
          name: data.name || 'Radio Station',
          description: data.description || `Listen to ${data.name || 'Radio Station'} live from ${data.country || 'around the world'}${data.city ? `, ${data.city}` : ''}.`
        },
        ...data
      };
      break;
    case 'BreadcrumbList':
      structuredData = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: (data || []).map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item.name || '',
          item: item.url || ''
        }))
      };
      break;
    case 'AudioObject':
      structuredData = {
        '@context': 'https://schema.org',
        '@type': 'AudioObject',
        name: data.name || 'Audio Content',
        contentUrl: data.streamUrl || '',
        encodingFormat: 'audio/mpeg',
        description: data.description || `Listen to ${data.name || 'audio content'}.`,
        duration: data.duration || 'PT00H00M',
        ...data
      };
      break;
    default:
      structuredData = {
        '@context': 'https://schema.org',
        ...data
      };
  }

  return (
    <script 
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};

export default StructuredData; 